import React from 'react';

type Props = {
    title: string
    subtitle?: string | null
    action?: React.ReactNode
}

function CardHeader({title, subtitle, action}: Props) {
    return (
        // <div className="border-b border-gray-200 bg-white px-4 py-5 sm:px-6">
        <div className="relative bg-white px-4 py-5 sm:px-6 sm:rounded-t-lg">
            <div className="-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                <div className="ml-4 mt-4">
                    <h2 className="text-lg font-medium leading-6 text-gray-900">{title}</h2>

                    {subtitle &&
                        <p className="mt-1 text-sm text-gray-500">
                            {subtitle}
                        </p>
                    }

                </div>
                <div className="ml-4 mt-4 flex-shrink-0">
                    {action}
                </div>
            </div>
        </div>
    );
}

export default CardHeader;